import { useMandatorVisibility } from "@helpers";
import { useMetrics } from "../components/SecurityFundamentals/hooks/useMetrics";
import { useSelectedMetricsAndMenuItems } from "../components/SecurityFundamentals/hooks/useSelectedMetricsAndMenuItems";
import { useFundamentalsSettings } from "./useFundamentalsSettings";

export const useFundamentalsMetrics = () => {
  const { allMetric } = useMetrics();
  const isVisible = useMandatorVisibility({ hideFor: ["kpmg-germany"] });

  const {
    savedMetrics,
    showMetric,
    hideMetric,
    toggleMetric,
    changeMetric,
    isLoading,
  } = useFundamentalsSettings({
    defaultMetrics: ["priceToEarnings", "netIncome"],
  });

  const { menuItems, selectedMetrics } = useSelectedMetricsAndMenuItems(
    savedMetrics,
    allMetric
  );

  const filteredMenuItems = isVisible ? menuItems : undefined;

  return {
    menuItems: filteredMenuItems,
    selectedMetrics,
    showMetric,
    hideMetric,
    toggleMetric,
    changeMetric,
    isLoading,
  };
};
